import { Component, Input } from '@angular/core'
import { PieChartConfiguration } from '../interfaces/pie-chart-configuration'
import { AggregationDataset } from '../../../../shared/interfaces/visualizations/aggregation-dataset.interface'

@Component({
  selector: 'app-pie-chart-legend',
  templateUrl: './pie-chart-legend.component.html',
  styleUrls: ['./pie-chart-legend.component.scss']
})
export class PieChartLegendComponent {
  @Input()
  dataset: AggregationDataset;

  @Input()
  colors: string[];
}
